export type Language = "en" | "es" | "de" | "pt-BR" | "fr";

export interface UiTranslations {
  home: string;
  pdfToolkit: string;
  editPdf: string;
  spinWheel: string;
  wheelOfNames: string;
  yesNoWheel: string;
  prizeWheel: string;
  exploreAllTools: string;
  navigationAndTools: string;
  rosterAndSetup: string;
  shuffle: string;
  sortAz: string;
  howManyToPick: string;
  removeWinnerFromList: string;
  readyWhenYouAre: string;
  picking: string;
  pickAgain: string;
  pickAName: string;
  pick: string;
  copyWinner: string;
  copy: string;
  remove: string;
  selectedWinners: string;
  namePicked: string;
  selectionHistory: string;
  popularWheels: string;
  decisionTools: string;
  aboutEduzuma: string;
  aboutAndPolicies: string;
  aboutUs: string;
  contactUs: string;
  privacyPolicy: string;
  termsOfUse: string;
  disclaimer: string;
  allRightsReserved: string;
  freeToolsHub: string;
  pdfHub: string;
  whatIs: string;
  howToUse: string;
  keyFeatures: string;
  benefitsOfUsing: string;
  proTips: string;
  whoShouldUse: string;
  faq: string;
  relatedTools: string;
  visitEduzuma: string;
  languageName: string;
  switchLanguage: string;
  footerDescription: string;
  eduzumaDescription: string;
}

export const DICTIONARY: Record<Language, UiTranslations> = {
  en: {
    home: "Home",
    pdfToolkit: "PDF Toolkit Pro",
    editPdf: "Edit PDF",
    spinWheel: "Spin Wheel",
    wheelOfNames: "Wheel of Names",
    yesNoWheel: "Yes or No Wheel",
    prizeWheel: "Prize Wheel",
    exploreAllTools: "Explore All 37 Free Tools",
    navigationAndTools: "Navigation & Tools",
    rosterAndSetup: "Roster & Setup",
    shuffle: "Shuffle",
    sortAz: "Sort A-Z",
    howManyToPick: "How many to pick",
    removeWinnerFromList: "Remove winner from list",
    readyWhenYouAre: "Ready when you are",
    picking: "Picking…",
    pickAgain: "Pick Again",
    pickAName: "Pick a Name",
    pick: "Pick",
    copyWinner: "Copy Winner",
    copy: "Copy",
    remove: "Remove",
    selectedWinners: "Selected Winners!",
    namePicked: "Name Picked!",
    selectionHistory: "Selection History",
    popularWheels: "Popular Wheels",
    decisionTools: "Decision Tools",
    aboutEduzuma: "About Eduzuma",
    aboutAndPolicies: "About & Policies",
    aboutUs: "About Picamini.online",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    disclaimer: "Disclaimer",
    allRightsReserved: "All rights reserved. Free Classroom & Decision Tools.",
    freeToolsHub: "Free Tools Hub",
    pdfHub: "PDF Toolkit Pro Hub",
    whatIs: "What is",
    howToUse: "How to Use",
    keyFeatures: "Key Features",
    benefitsOfUsing: "Benefits of Using",
    proTips: "Pro Tips for Best Results",
    whoShouldUse: "Who Should Use This Tool?",
    faq: "Frequently Asked Questions (FAQ)",
    relatedTools: "Related Free Tools",
    visitEduzuma: "Visit Eduzuma →",
    languageName: "English",
    switchLanguage: "Español",
    footerDescription: "Fast, privacy-focused browser tools for teachers, students, event hosts, and facilitators. 100% free with no account setup on Picamini.online.",
    eduzumaDescription: "Generate perfect worksheets in seconds. Eduzuma turns any topic into curriculum-aligned worksheets, quizzes and printables — with manual tools always free and AI Support when you want a faster draft.",
  },
  es: {
    home: "Inicio",
    pdfToolkit: "Herramientas PDF",
    editPdf: "Editar PDF",
    spinWheel: "Ruleta Aleatoria",
    wheelOfNames: "Ruleta de Nombres",
    yesNoWheel: "Ruleta del Sí o No",
    prizeWheel: "Ruleta de Premios",
    exploreAllTools: "Explorar las 37 Herramientas Gratis",
    navigationAndTools: "Navegación y Herramientas",
    rosterAndSetup: "Lista y Configuración",
    shuffle: "Mezclar",
    sortAz: "Ordenar A-Z",
    howManyToPick: "Cantidad a seleccionar",
    removeWinnerFromList: "Eliminar ganador de la lista",
    readyWhenYouAre: "Listo cuando quieras",
    picking: "Seleccionando…",
    pickAgain: "Elegir de Nuevo",
    pickAName: "Elegir un Nombre",
    pick: "Elegir",
    copyWinner: "Copiar Ganador",
    copy: "Copiar",
    remove: "Eliminar",
    selectedWinners: "¡Ganadores Seleccionados!",
    namePicked: "¡Nombre Seleccionado!",
    selectionHistory: "Historial de Selecciones",
    popularWheels: "Ruletas Populares",
    decisionTools: "Herramientas de Decisión",
    aboutEduzuma: "Sobre Eduzuma",
    aboutAndPolicies: "Información y Políticas",
    aboutUs: "Sobre Picamini.online",
    contactUs: "Contacto",
    privacyPolicy: "Política de Privacidad",
    termsOfUse: "Términos de Uso",
    disclaimer: "Aviso Legal",
    allRightsReserved: "Todos los derechos reservados. Herramientas gratuitas para el aula y toma de decisiones.",
    freeToolsHub: "Centro de Herramientas",
    pdfHub: "Centro de Herramientas PDF",
    whatIs: "¿Qué es",
    howToUse: "Cómo usar",
    keyFeatures: "Características principales",
    benefitsOfUsing: "Beneficios de usar",
    proTips: "Consejos para mejores resultados",
    whoShouldUse: "¿Quién debería usar esta herramienta?",
    faq: "Preguntas Frecuentes (FAQ)",
    relatedTools: "Herramientas Relacionadas",
    visitEduzuma: "Visitar Eduzuma →",
    languageName: "Español",
    switchLanguage: "English",
    footerDescription: "Herramientas rápidas y privadas en el navegador para docentes, estudiantes y facilitadores. 100% gratis y sin registro en Picamini.online.",
    eduzumaDescription: "Genera fichas y ejercicios perfectos en segundos. Eduzuma convierte cualquier tema en fichas educativas alineadas con el currículo, cuestionarios e imprimibles.",
  },
  de: {
    home: "Startseite",
    pdfToolkit: "PDF-Werkzeuge",
    editPdf: "PDF bearbeiten",
    spinWheel: "Zufallsrad",
    wheelOfNames: "Glücksrad Namensauswahl",
    yesNoWheel: "Ja Nein Rad",
    prizeWheel: "Gewinnrad Online",
    exploreAllTools: "Alle 37 kostenlosen Tools erkunden",
    navigationAndTools: "Navigation & Werkzeuge",
    rosterAndSetup: "Namensliste & Einstellungen",
    shuffle: "Mischen",
    sortAz: "A-Z sortieren",
    howManyToPick: "Anzahl Auslosungen",
    removeWinnerFromList: "Gewinner aus Liste entfernen",
    readyWhenYouAre: "Bereit zur Auslosung",
    picking: "Wähle aus…",
    pickAgain: "Erneut ziehen",
    pickAName: "Name auslosen",
    pick: "Ziehen",
    copyWinner: "Gewinner kopieren",
    copy: "Kopieren",
    remove: "Entfernen",
    selectedWinners: "Gezogene Gewinner!",
    namePicked: "Name gezogen!",
    selectionHistory: "Auslosungsverlauf",
    popularWheels: "Beliebte Glücksräder",
    decisionTools: "Entscheidungshilfen",
    aboutEduzuma: "Über Eduzuma",
    aboutAndPolicies: "Über uns & Richtlinien",
    aboutUs: "Über Picamini.online",
    contactUs: "Kontakt",
    privacyPolicy: "Datenschutzrichtlinie",
    termsOfUse: "Nutzungsbedingungen",
    disclaimer: "Haftungsausschluss",
    allRightsReserved: "Alle Rechte vorbehalten. Kostenlose Unterrichts- & Entscheidungstools.",
    freeToolsHub: "Tool-Übersicht",
    pdfHub: "PDF Toolkit Pro Übersicht",
    whatIs: "Was ist",
    howToUse: "Anleitung:",
    keyFeatures: "Hauptfunktionen",
    benefitsOfUsing: "Vorteile von",
    proTips: "Profi-Tipps für beste Ergebnisse",
    whoShouldUse: "Für wen ist dieses Tool geeignet?",
    faq: "Häufig gestellte Fragen (FAQ)",
    relatedTools: "Verwandte kostenlose Tools",
    visitEduzuma: "Eduzuma besuchen →",
    languageName: "Deutsch",
    switchLanguage: "Sprache wechseln",
    footerDescription: "Schnelle, datenschutzfreundliche Online-Tools für Lehrkräfte, Schüler und Moderatoren. 100% kostenlos ohne Registrierung auf Picamini.online.",
    eduzumaDescription: "Erstellen Sie perfekte Arbeitsblätter in Sekunden. Eduzuma verwandelt jedes Thema in lehrplangerechte Arbeitsblätter, Tests und Druckvorlagen.",
  },
  "pt-BR": {
    home: "Início",
    pdfToolkit: "Ferramentas PDF",
    editPdf: "Editar PDF",
    spinWheel: "Roleta da Sorte",
    wheelOfNames: "Roleta de Nomes",
    yesNoWheel: "Roleta Sim ou Não",
    prizeWheel: "Roleta de Prêmios",
    exploreAllTools: "Explorar Todas as 37 Ferramentas Grátis",
    navigationAndTools: "Navegação e Ferramentas",
    rosterAndSetup: "Lista e Configuração",
    shuffle: "Embaralhar",
    sortAz: "Ordenar A-Z",
    howManyToPick: "Quantidade a sortear",
    removeWinnerFromList: "Remover vencedor da lista",
    readyWhenYouAre: "Pronto quando você quiser",
    picking: "Sorteando…",
    pickAgain: "Sortear Novamente",
    pickAName: "Sortear um Nome",
    pick: "Sortear",
    copyWinner: "Copiar Vencedor",
    copy: "Copiar",
    remove: "Remover",
    selectedWinners: "¡Vencedores Sorteados!",
    namePicked: "¡Nome Sorteado!",
    selectionHistory: "Histórico de Sorteios",
    popularWheels: "Roletas Populares",
    decisionTools: "Ferramentas de Decisão",
    aboutEduzuma: "Sobre a Eduzuma",
    aboutAndPolicies: "Sobre e Políticas",
    aboutUs: "Sobre o Picamini.online",
    contactUs: "Contato",
    privacyPolicy: "Política de Privacidade",
    termsOfUse: "Termos de Uso",
    disclaimer: "Aviso Legal",
    allRightsReserved: "Todos os direitos reservados. Ferramentas gratuitas para sala de aula e sorteios.",
    freeToolsHub: "Central de Ferramentas",
    pdfHub: "Central de Ferramentas PDF",
    whatIs: "O que é",
    howToUse: "Como Usar",
    keyFeatures: "Recursos Principais",
    benefitsOfUsing: "Vantagens de Usar",
    proTips: "Dicas Práticas",
    whoShouldUse: "Quem Deve Usar Esta Ferramenta?",
    faq: "Perguntas Frequentes (FAQ)",
    relatedTools: "Ferramentas Relacionadas",
    visitEduzuma: "Visitar Eduzuma →",
    languageName: "Português (BR)",
    switchLanguage: "Mudar Idioma",
    footerDescription: "Ferramentas rápidas e privadas no navegador para professores, estudantes e facilitadores. 100% grátis e sem cadastro no Picamini.online.",
    eduzumaDescription: "Gere atividades escolares perfeitas em segundos. A Eduzuma transforma qualquer conteúdo em atividades, quizzes e impressos alinhados ao currículo.",
  },
  fr: {
    home: "Accueil",
    pdfToolkit: "Outils PDF",
    editPdf: "Modifier un PDF",
    spinWheel: "Roue de la Fortune",
    wheelOfNames: "Roue des Prénoms",
    yesNoWheel: "Roue Oui ou Non",
    prizeWheel: "Roue des Cadeaux",
    exploreAllTools: "Explorer les 37 Outils Gratuits",
    navigationAndTools: "Navigation & Outils",
    rosterAndSetup: "Liste & Configuration",
    shuffle: "Mélanger",
    sortAz: "Trier A-Z",
    howManyToPick: "Nombre à tirer",
    removeWinnerFromList: "Retirer le gagnant de la liste",
    readyWhenYouAre: "Prêt quand vous l'êtes",
    picking: "Tirage en cours…",
    pickAgain: "Tirer à nouveau",
    pickAName: "Tirer un prénom",
    pick: "Tirer au sort",
    copyWinner: "Copier le gagnant",
    copy: "Copier",
    remove: "Retirer",
    selectedWinners: "Gagnants Sélectionnés !",
    namePicked: "Prénom Tiré !",
    selectionHistory: "Historique des Tirages",
    popularWheels: "Roues Populaires",
    decisionTools: "Outils de Décision",
    aboutEduzuma: "À propos d'Eduzuma",
    aboutAndPolicies: "À propos & Mentions",
    aboutUs: "À propos de Picamini.online",
    contactUs: "Contact",
    privacyPolicy: "Politique de Confidentialité",
    termsOfUse: "Conditions d'Utilisation",
    disclaimer: "Mentions Légales",
    allRightsReserved: "Tous droits réservés. Outils gratuits pour la classe et la prise de décision.",
    freeToolsHub: "Centre d'Outils Gratuits",
    pdfHub: "Centre d'Outils PDF",
    whatIs: "Qu'est-ce que",
    howToUse: "Guide d'utilisation",
    keyFeatures: "Fonctionnalités Clés",
    benefitsOfUsing: "Avantages de l'outil",
    proTips: "Conseils d'utilisation",
    whoShouldUse: "À qui s'adresse cet outil ?",
    faq: "Foire Aux Questions (FAQ)",
    relatedTools: "Outils Gratuits Associés",
    visitEduzuma: "Visiter Eduzuma →",
    languageName: "Français",
    switchLanguage: "Changer de langue",
    footerDescription: "Outils rapides et respectueux de la vie privée dans le navigateur pour enseignants, élèves et animateurs. 100% gratuit et sans inscription sur Picamini.online.",
    eduzumaDescription: "Générez des fiches d'exercices parfaites en quelques secondes. Eduzuma transforme n'importe quel sujet en fiches imprimables et quiz conformes aux programmes.",
  },
};

export function getTranslation(lang: Language): UiTranslations {
  return DICTIONARY[lang] || DICTIONARY.en;
}
